module.exports = __webpack_public_path__ + "images/Livongo_Health-28f8ca.png";